// extracted by mini-css-extract-plugin
module.exports = {"column-values":"Audit_column-values__3MtSN"};